import { ScimEntityService } from './ScimEntityService';
import { ScimUserService } from './ScimUserService';
import { ScimPhotoService } from './ScimPhotoService';
import { ScimSchemaService } from './ScimSchemaService';

/**
 * Module-level singleton instances for SCIM services.
 * These are stateless wrappers around the shared axios instance,
 * so a single instance per service type is safe and eliminates
 * redundant instantiations across 40+ components.
 */
export const entityService = new ScimEntityService();
export const userService = new ScimUserService();
export const photoService = new ScimPhotoService();
export const schemaService = new ScimSchemaService();
